export type AppErrorArgs = {
    status: number;
    type: string;
    title: string;
    detail?: string | unknown;
    // Making `instance` optional for now because most errors are thrown from the service layer,
    // which does not have access to the request context (and thus cannot set the `instance` field).
    // This is a temporary workaround to avoid breaking existing functionality.
    // In the future, error formatting — including setting `instance` — should be handled
    // centrally in the global error middleware where request context is available.
    instance?: string;
    [key: string]: unknown;
};

export const ErrorTypes = {
    INVALID_INPUT: 'https://example.com/probs/invalid-input',
    UNAUTHORIZED_ACCESS: 'https://petsmart.com/probs/unauthorized',
    RESOURCE_NOT_FOUND: 'https://petsmart.com/probs/resource-not-found',
    INTERNAL_SERVER_ERROR: 'https://petsmart.com/probs/internal-server-error',
};

export class AppError extends Error {
    status: number;
    type: string;
    title: string;
    detail: string | unknown;
    instance?: string;
    [key: string]: unknown;

    constructor({ status, type, title, detail, instance, ...extraFields }: AppErrorArgs) {
        super(AppError.buildMessage(title, detail));

        this.name = new.target.name;
        this.status = status;
        this.type = type;
        this.title = title;
        this.detail = detail;
        this.instance = instance;
        Object.assign(this, extraFields);
    }

    private static buildMessage(title: string, detail?: string | unknown) {
        if (typeof detail === 'string' && detail) {
            return `${title}: ${detail}`;
        }

        return title;
    }
}
